// App.vue shows a global spinner (#loaderSection) until a view hides it.
// Legacy views do this inline in created(); security views call this in setup.
export function useHideGlobalLoader() {
  const loader = document.getElementById('loaderSection');
  if (loader) loader.classList.add('d-none');
}
